export const isProduction = process.env.NODE_ENV === 'production'

export const breakpoint = {
  phone: {
    xs: 0,
    s: 370,
    m: 576,
  },
  tablet: 768,
  desktop: {
    xs: 992,
    s: 1125,
    m: 1300,
    l: 1500,
    xl: 1700,
    xxl: 2000,
  },
}

export const getColorMode = (rgbColor) => {
  // http://www.w3.org/TR/AERT#color-contrast
  const brightness = Math.round((rgbColor.r * 299 + rgbColor.g * 587 + rgbColor.b * 114) / 1000)
  const colorMode = brightness > 125 ? 'light' : 'dark'

  return colorMode
}

export const hexToRgb = (hexColor) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor)

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null
}

// export const removeActive = (
//   items: NodeListOf<HTMLAnchorElement> | NodeListOf<HTMLButtonElement> | NodeListOf<HTMLElement>
// ): void => {
//   Array.prototype.forEach.call(items, (item: HTMLElement) => {
//     if (item.classList.contains('active')) {
//       item.classList.remove('active')
//     }
//   })
// }

// export const scrollToTop = () => window.scroll({ top: 0, left: 0, behavior: 'smooth' })

// export function numberWithCommas(number?: string | number): string {
//   if (!number) {
//     return ''
//   }

//   const formatted = typeof number === 'number' ? Math.round(number).toString() : number

//   return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
// }

// export function formatPrice(price: number): string {
//   if (Number.isNaN(price) || price === null) return ''

//   if (price === 0) return '0'

//   return `${numberWithCommas(price)}`
// }

// // URL Parameters
// export const getUrlParameter = (key: string) => {
//   const queryString = window.location.search
//   const urlParams = new URLSearchParams(queryString)

//   return urlParams.get(key)
// }

// export const insertParameter = (key: string, value: string) => {
//   let windowUrl = window.location.href

//   const seperator = windowUrl.indexOf('?') > -1 ? '&' : '?'
//   const alreadyHasKey = windowUrl.indexOf(key) > -1

//   if (alreadyHasKey) {
//     windowUrl = removeURLParameter(windowUrl, key)
//   }

//   const newUrl = `${windowUrl}${seperator}${key}=${value}`

//   window.history.pushState({ path: newUrl }, '', newUrl)
// }

// export const removeURLParameter = (url, parameter) => {
//   //prefer to use l.search if you have a location/link object
//   const urlparts = url.split('?')

//   if (urlparts.length >= 2) {
//     const prefix = encodeURIComponent(parameter) + '='
//     const pars = urlparts[1].split(/[&;]/g)

//     //reverse iteration as may be destructive
//     for (let i = pars.length; i-- > 0; ) {
//       //idiom for string.startsWith
//       if (pars[i].lastIndexOf(prefix, 0) !== -1) {
//         pars.splice(i, 1)
//       }
//     }

//     url = urlparts[0] + '?' + pars.join('&')

//     return url
//   } else {
//     return url
//   }
// }

// export const GetFocused = () => {
//   let focused_element = null

//   if (
//     document.hasFocus() &&
//     document.activeElement !== document.body &&
//     document.activeElement !== document.documentElement
//   ) {
//     focused_element = document.activeElement
//   }

//   return focused_element
// }

// declare let grecaptcha: any

// export const validateRecaptcha = (): boolean => {
//   const v = grecaptcha.getResponse()

//   if (v.length === 0) {
//     return false
//   }

//   return true
// }

// export const handleRecaptcha = (event: Event, element: HTMLElement): void => {
//   if (element) {
//     if (!element.classList.contains('hide')) {
//       element.classList.add('hide')
//     }

//     if (!validateRecaptcha()) {
//       event.preventDefault()
//       element.classList.remove('hide')
//     }
//   }
// }

// export const postForm = async (form: HTMLFormElement): Promise<Response> => {
//   const formData = new FormData(form)
//   //@ts-ignore
//   const dataString = new URLSearchParams(formData).toString()

//   const response = await fetch(form.getAttribute('action'), {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//     },
//     body: dataString,
//   })

//   if (response) {
//     return response
//   }
// }

// export const convertBool = (string: string): boolean => {
//   let value = false

//   if (string) {
//     if (string === 'true' || string === '1') {
//       value = true
//     }

//     if (string === 'false' || string == '0') {
//       value = false
//     }
//   }

//   return value
// }

// export const validateStep = (inputs: NodeListOf<HTMLInputElement>): boolean => {
//   if (!inputs) return

//   let isValid = true

//   Array.prototype.forEach.call(inputs, (item) => {
//     if (item.type !== 'checkbox' || item.type !== 'radio') {
//       if (item.value <= 0) {
//         isValid = false
//       }
//     } else {
//       if (item.checked) {
//         return false
//       }
//     }
//   })

//   return isValid
// }
